import { useEffect } from 'react';
import { Modal, notification } from 'antd';
import { useSelector } from 'react-redux';

import {
  getSelectedLists,
  getView,
  getIncludePausedLists,
  getShowMyListsOnly,
} from 'selectors/lists';
import { usePost } from 'hooks';
import { bulkDisableList } from 'services/api';
import { disablePermissionsError } from '../constants';

const BulkDisable = ({ onClose }) => {
  const view = useSelector(getView);
  const members = useSelector(getSelectedLists);
  const includePausedLists = useSelector(getIncludePausedLists);
  const showMyListsOnly = useSelector(getShowMyListsOnly);

  const [{ res: success, loading, error }, postDisable] = usePost({
    url: bulkDisableList(view),
  });

  useEffect(() => {
    if (success) {
      onClose({ fetchLists: true });
    }
  }, [onClose, success]);

  useEffect(() => {
    if (error) {
      onClose();
    }
    if (error?.status === 412) {
      notification.open({
        message: 'Invalid List Operation',
        description: <div>{disablePermissionsError}</div>,
        placement: 'bottomLeft',
      });
    }
  }, [error, onClose, success]);

  const handleDisable = () => {
    postDisable({
      applyToAll: members.all,
      ids: Object.keys(members.include).map(x => +x),
      excludeIds: Object.keys(members.exclude).map(x => +x),
      includeDisabled: includePausedLists,
      onlyShowMine: showMyListsOnly,
    });
  };

  return (
    <Modal
      open
      title='Bulk Pause'
      onCancel={onClose}
      onOk={handleDisable}
      okText='Yes'
      okButtonProps={{ disabled: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      Are you sure you want to disable selected lists?
    </Modal>
  );
};

export default BulkDisable;
